import { Outlet } from "react-router";
import { persistor } from "../Store/store";
//-------------------------------------------------url
export const base_url = "https://wd.demobw.com/webapi/api";
export const img_url = "https://wd.demobw.com/";
export const helmet_url = "https://wd.demobw.com/";
export const klaviyo_url = "https://wd.demobw.com";
export const Klevu_test_key = 'klevu-170170991840112663'
export const s3_img_url = 'https://dl2vs6wk2ewna.cloudfront.net/wdd/images/'
//--------------------------------------------------Api header data
export const postHeader = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

export const logout = async() => {
  await persistor.flush();
  localStorage.clear();
  sessionStorage.clear();
  window.location.reload();
  window.location.replace("/") 
  sessionStorage.setItem("path","")
}


export const ErrorImg = (id) => {
    const img = "https://dl2vs6wk2ewna.cloudfront.net/images/no_image_available.webp";

    document.getElementById(id).src = img;
}